let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("f7nCb")]).then(() => parcelRequire('4xvKn'));